import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    
    // EmailJS配置
    const serviceId = 'service_eoi1n0e';
    const templateId = 'template_ylt91ba';
    const publicKey = '222AtMFb7BgCIE1Xl';
    
    emailjs.sendForm(serviceId, templateId, form.current, publicKey)
      .then((result) => {
        console.log('邮件发送成功！', result.text);
        setIsSubmitting(false);
        setSubmitStatus('success');
        
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
        
        setTimeout(() => {
          setSubmitStatus(null);
        }, 3000);
      })
      .catch((error) => {
        console.error('邮件发送失败:', error.text);
        setIsSubmitting(false);
        setSubmitStatus('error');
        setErrorMessage('发送失败，请稍后重试或直接联系我们。');
      });
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1 className="contact-title">联系我</h1>
        <p className="contact-subtitle">有兴趣合作？请填写下面的表格。</p>
        
        <div className="contact-content">
          <div className="contact-form-container">
            {submitStatus === 'success' ? (
              <div className="form-success-message">
                <div className="success-icon">✓</div>
                <h3>消息已发送！</h3>
                <p>感谢您的留言，我会尽快回复您。</p>
              </div>
            ) : submitStatus === 'error' ? (
              <div className="form-error-message">
                <div className="error-icon">!</div>
                <h3>发送失败</h3>
                <p>{errorMessage}</p>
                <button 
                  className="contact-button retry-button"
                  onClick={() => setSubmitStatus(null)}
                >
                  重试
                </button>
              </div>
            ) : (
              <form ref={form} className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="您的全名"
                    required
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="您的邮箱" 
                    required
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <input 
                    type="text" 
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="咨询类型"
                    required
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="您的留言" 
                    required
                    className="form-textarea"
                    rows="6"
                  ></textarea>
                </div>
                
                <input 
                  type="hidden" 
                  name="to_email" 
                  value="zhujieyohji@gmail.com" 
                />
                
                <button 
                  type="submit" 
                  className="contact-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '发送中...' : '联系我'}
                </button>
              </form>
            )}
          </div>

          <div className="contact-info">
            <div className="contact-message">
              <h3>想直接交流？</h3>
              <p>如果您想讨论产品、作品集或任何事情，请使用日历链接预约时间：</p>
              <div className="calendar-icon">
                <img src="/images/calendar-icon.png" alt="日历图标" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 